<template>
    <b-modal v-if="!loading" id="billing_form" ref="billing_form"
             @hidden="resetForm" no-close-on-backdrop
             modal-class="modal-right modal-dialog-scrollable">

        <template v-slot:modal-title>
            {{ !edit ? 'Add New Billing' : 'Edit Billing' }}
        </template>

        <div class="d-flex flex-row mb-4">
            <span class="iconsminds-add mr-3 menu-icon-style"/>

            <p class="my-auto">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi
                dolores quod, repellendus similique sint.
            </p>
        </div>

        <b-form>
            <b-row v-if="validationError">
                <b-colxx md="12">
                    <b-alert class="text-center" show variant="danger"
                             v-text="validationError"/>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Facilities" class="has-float-label">
                        <template v-slot:label>
                            <span>Facilities <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateFacility" v-model="selected.facility" :options="facilities"
                                  :border-danger="'facility_id' in errors"/>

                        <b-form-invalid-feedback :state="!'facility_id' in errors"
                                                 v-text="'facility_id' in errors ? errors.facility_id[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <month-picker @month-changed="updateMonth" @year-changed="updateYear"
                          :min-year="today.getFullYear() - 5" :max-year="today.getFullYear()"/>

            <b-row>
                <b-colxx md="12" class="mb-4">
                    <b-form-group label="Notes" class="has-float-label">
                        <b-form-textarea v-model="form.notes" rows="6" placeholder="Notes"/>
                    </b-form-group>
                </b-colxx>
            </b-row>
        </b-form>

        <template slot="modal-footer">
            <b-button variant="outline-secondary" @click="hideModal('billing_form')" v-text="'Cancel'"/>

            <state-button v-if="!edit" variant="primary" :click="submitBilling">Submit</state-button>

            <state-button v-else variant="primary" :click="updateBilling">Update</state-button>
        </template>
    </b-modal>
</template>

<script>
    import {mapGetters} from "vuex";
    import moment from "moment";
    import StateButton from "../../../../../components/Common/StateButton";
    import MonthPicker from "../../../../../components/Monthpicker/MonthPicker";


    export default {
        name: "BillingFormModal",

        components: {
            MonthPicker,
            StateButton,
        },

        props: [
            'edit'
        ],

        data() {
            return{
                loading: false,
                today: new Date(),
                selected: {
                    facility: [],
                },
                validationError: null,
            }
        },

        computed: {
            ...mapGetters({
                form: 'getBillingForm',
                facilities: 'getSelectFacilities',
                errors: 'getBillingErrors',
            })
        },

        watch: {

        },

        mounted() {
            this.getform();
        },

        methods: {
            async getform() {
                await this.$store.dispatch('fetchSelectFacilities');

                return this.loading = false;
            },

            submitBilling() {
                return new Promise((success, fail) => {
                    this.$store.dispatch('submitBilling', this.form)
                        .then(response => {
                            setTimeout(() => {
                                success();

                                this.$emit('updated');

                                this.resetForm();

                                this.$notify('success filled', 'Success!', 'New bill generated!', {
                                    duration: 4000,
                                    permanent: false
                                });

                                this.hideModal('billing_form');
                            }, 2000);
                        })
                        .catch(error => {
                            if (error.response.data.error) {
                                this.validationError = error.response.data.error;
                            }

                            setTimeout(() => {
                                fail();
                            }, 1000);
                        });
                })
            },

            hideModal(refname) {
                this.$refs[refname].hide();
            },

            resetForm() {
                this.$store.commit('setBillingForm');

                this.validationError = null;

                this.selected.facility = [];
            },

            updateFacility(field) {
                if (field) {
                    this.form.facility_id = field.facility_id;
                } else {
                    this.form.facility_id = '';
                }
                this.validationError = null;

                'facility_id' in this.errors ? delete this.errors.facility_id : '';
            },

            updateMonth(field) {
                if (field) {
                    this.form.date = this.form.date.slice(0, 4) + "-" + field.value + "-" + this.form.date.slice(8, 10);
                }
                'date' in this.errors ? delete this.errors.date && this.dateSelectKey++ : '';
            },

            updateYear(field) {
                if (field) {
                    this.form.date = field.value + "-" + this.form.date.slice(5, 7) + "-" + this.form.date.slice(8, 10);
                }
                'date' in this.errors ? delete this.errors.date && this.dateSelectKey++ : '';
            },
        }
    }
</script>

<style scoped>

</style>
